module.exports = __webpack_public_path__ + "img/D6.cbda1313.png";